import { render, staticRenderFns } from "./SingleMode.vue?vue&type=template&id=2965dd04"
import script from "./SingleMode.vue?vue&type=script&lang=js"
export * from "./SingleMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports